import request from '@webtrader/core/request';

interface IUpdateLanguageResponse {
  description: string;
}

export default {
  updateLanguage: () => {
    return request.patch<IUpdateLanguageResponse>('/api/user/v1/language/platform');
  }
};
